import { v4 as uuidv4 } from "uuid";

const HTS_ASSIST_ANONYMOUS_USER_ID_STORAGE_KEY = "htsAssistAnonymousUserId";

const normalizeUserId = (value?: string | null): string | undefined => {
  const normalizedValue = value?.trim();

  return normalizedValue ? normalizedValue : undefined;
};

const getOrCreateHtsAssistAnonymousUserId = (): string => {
  if (typeof window === "undefined") {
    return uuidv4();
  }

  try {
    const storedUserId = normalizeUserId(
      window.localStorage.getItem(HTS_ASSIST_ANONYMOUS_USER_ID_STORAGE_KEY)
    );

    if (storedUserId) {
      return storedUserId;
    }

    const anonymousUserId = uuidv4();
    window.localStorage.setItem(
      HTS_ASSIST_ANONYMOUS_USER_ID_STORAGE_KEY,
      anonymousUserId
    );

    return anonymousUserId;
  } catch {
    return uuidv4();
  }
};

// `currentUserId` is a client-side-only value: the chat widget uses it solely
// to stamp the local optimistic echo of the user's own outgoing message. It is
// never published over LiveKit (only the message text + topic are sent) and is
// not read by the agent, which identifies the participant via the server-issued
// token. RBC's session exposes no Hopper user id client-side, so we use a
// persisted anonymous UUID — matching whopper's anonymous-UUID fallback and
// commerce-portals' cosmetic treatment of this prop.
export const resolveHtsAssistUserId = (): string =>
  getOrCreateHtsAssistAnonymousUserId();
